import script from "./AnunciaView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnunciaView.vue?vue&type=script&setup=true&lang=js"

import "./AnunciaView.vue?vue&type=style&index=0&id=29123f12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29123f12"]])

export default __exports__